import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { services } from '../../apis';

const checkRepeatition = (data: any[]) => {
	console.log('This is the data ', data);
	data = data.filter(
		(value, index, self) =>
			index === self.findIndex((t) => t.id === value.id),
	);

	console.log('From Set', data);
	return data;
};

export const getRevisionSheets = createAsyncThunk("gym/revision", async(arg)=>{
	const data = await services.codingQuestionService.getRevisionSheets()
	return data
} )

export const fetchRevisionSheetQuestions = createAsyncThunk(
	'gym/fetchQuestions',
	async (arg, { getState }) => {
		const state = getState();

		const {
			solvedStatus,
			difficulty,
			page,
			name,
			tags,
			bookmarked,
			courseId,
			revisionSheetId,
			questionSource,
		} =
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			//@ts-ignore
			state.gym;
		const diffArray = [];

		for (let i = 0; i < 3; i++) {
			if (difficulty[i] && i === 0) {
				diffArray.push('EASY');
			} else if (difficulty[i] && i === 1) {
				diffArray.push('MEDIUM');
			} else if (difficulty[i] && i === 2) {
				diffArray.push('HARD');
			}
		}

		const data = await services.courseService.getAllCodingQuestionsModular(
			page,
			solvedStatus,
			tags,
			diffArray,
			bookmarked,
			name,
			revisionSheetId,
			questionSource,
		);

		const temp = { ...data };

		temp.questions = [...checkRepeatition(data.questions)];

		// const status = await services.courseService.getCodingQuestionsStatus();
		// console.log({ questions: data, status });
		return temp;
	},
);

export const fetchGymQuestions = createAsyncThunk(
	'gym/fetchQuestions',
	async (arg, { getState }) => {
		const state = getState();

		const {
			solvedStatus,
			difficulty,
			page,
			name,
			tags,
			bookmarked,
			courseId,
			questionSource,
		} =
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			//@ts-ignore
			state.gym;
		const diffArray = [];

		for (let i = 0; i < 3; i++) {
			if (difficulty[i] && i === 0) {
				diffArray.push('EASY');
			} else if (difficulty[i] && i === 1) {
				diffArray.push('MEDIUM');
			} else if (difficulty[i] && i === 2) {
				diffArray.push('HARD');
			}
		}

		const data = await services.courseService.getAllCodingQuestions(
			page,
			solvedStatus,
			tags,
			diffArray,
			bookmarked,
			name,
			courseId,
			questionSource,
		);

		const temp = { ...data };

		temp.questions = [...checkRepeatition(data.questions)];

		// const status = await services.courseService.getCodingQuestionsStatus();
		// console.log({ questions: data, status });
		return temp;
	},
);


export const fetchGymConceptualQuestions = createAsyncThunk(
	'gym/fetchQuestions',
	async (arg, { getState }) => {
		const state = getState();

		const {
			solvedStatus,
			difficulty,
			page,
			name,
			tags,
			bookmarked,
			courseId,
			questionSource,
		} =
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			//@ts-ignore
			state.gym;
		const diffArray = [];

		for (let i = 0; i < 3; i++) {
			if (difficulty[i] && i === 0) {
				diffArray.push('EASY');
			} else if (difficulty[i] && i === 1) {
				diffArray.push('MEDIUM');
			} else if (difficulty[i] && i === 2) {
				diffArray.push('HARD');
			}
		}

		const data = await services.courseService.getAllConceptualQuestions(
			page,
			solvedStatus,
			tags,
			diffArray,
			bookmarked,
			name,
			courseId,
			questionSource,
		);

		const temp = { ...data };

		temp.questions = [...checkRepeatition(data.questions)];

		// const status = await services.courseService.getCodingQuestionsStatus();
		// console.log({ questions: data, status });
		return temp;
	},
);

export const fetchWebDevGymQuestions = createAsyncThunk(
	'gym/fetchWebDevQuestions',
	async (arg, { getState }) => {
		const state = getState();

		const {
			solvedStatus,
			difficulty,
			page,
			name,
			tags,
			bookmarked,
			courseId,
			questionSource,
		} =
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			//@ts-ignore
			state.gym;
		const diffArray = [];

		for (let i = 0; i < 3; i++) {
			if (difficulty[i] && i === 0) {
				diffArray.push('EASY');
			} else if (difficulty[i] && i === 1) {
				diffArray.push('MEDIUM');
			} else if (difficulty[i] && i === 2) {
				diffArray.push('HARD');
			}
		}

		const data = await services.courseService.getAllWebDevQuestions(
			page,
			solvedStatus,
			tags,
			diffArray,
			bookmarked,
			name,
			courseId,
			questionSource,
		);

		const temp = { ...data };

		temp.questions = [...checkRepeatition(data.questions)];

		// const status = await services.courseService.getCodingQuestionsStatus();
		// console.log({ questions: data, status });
		return temp;
	},
);

export const addBookmark = createAsyncThunk(
	'gym/addBookmark',
	async (input: any, { getState }) => {
		const state = getState();
		console.log('el');
		const { filteredData } =
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			//@ts-ignore
			state.gym;
		console.log('filteredData', filteredData.questions);
		const data = await services.courseService.addBookmark(input);
		console.log('data', data);
		const questions = filteredData.questions;
		try {
			const updatedQuestions = questions.map((el: any) => {
				console.log('el');
				const ele = { ...el };
				if (el.id === input.questionId) {
					ele.bookmarked = true;
				}
				return ele;
			});

			console.log('updatedQuestions', updatedQuestions);
			const temp = { ...filteredData };
			console.log('temp', temp);
			temp.questions = updatedQuestions;
			console.log('updated', temp);
			return temp;
		} catch (err) {
			console.log(err);
		}
	},
);

export const removeBookmark = createAsyncThunk(
	'gym/removeBookmark',
	async (input: any, { getState }) => {
		const state = getState();
		console.log('el');
		const { filteredData } =
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			//@ts-ignore
			state.gym;
		console.log('filteredData', filteredData.questions);
		const data = await services.courseService.removeBookmark(input);
		console.log('data', data);
		const questions = filteredData.questions;
		try {
			const updatedQuestions = questions.map((el: any) => {
				console.log('el');
				const ele = { ...el };
				if (el.id === input.questionId) {
					ele.bookmarked = false;
				}
				return ele;
			});

			console.log('updatedQuestions', updatedQuestions);
			const temp = { ...filteredData };
			console.log('temp', temp);
			temp.questions = updatedQuestions;
			console.log('updated', temp);
			return temp;
		} catch (err) {
			console.log(err);
		}
	},
);

interface GymState {
	// filters
	page: string;
	difficulty: boolean[];
	tags: string[];
	name: string;
	curPageRange: number;
	solvedStatus: number;
	bookmarked: boolean;
	courseId: string;
	questionSource: string;
	filterCourseName: string;
	// final data
	filteredData: any;
	revisionSheets:any;
	revisionSheetId:string;
	// extra
	gymloading: boolean;
	error: {
		state: boolean;
		message: string;
	};
}

const initialState: GymState = {
	// filters
	page: '1',
	difficulty: [false, false, false],
	tags: [],
	name: '',
	curPageRange: 1,
	solvedStatus: 2,
	bookmarked: false,
	courseId: '',
	questionSource: '',
	filterCourseName: '',
	revisionSheets:null,
	revisionSheetId:"all_ques",
	// final data
	filteredData: null,
	// extra
	gymloading: true,
	error: {
		state: false,
		message: '',
	},
};

const resetPageToOne = () => {
	// const temp = document.getElementsByClassName('MuiPaginationItem-page');
	// for (let i = 0; i < temp.length; i++) {
	// 	if (temp[i].ariaCurrent) {
	// 		document.getElementsByClassName('MuiPaginationItem-page')[
	// 			i
	// 		].ariaCurrent = null;
	// 	}
	// 	document
	// 		.getElementsByClassName('MuiPaginationItem-page')
	// 		[i].classList.remove('Mui-selected');
	// }
	// if (temp.length > 0) {
	// 	document.getElementsByClassName(
	// 		'MuiPaginationItem-page'
	// 	)[0].ariaCurrent = 'true';
	// 	document
	// 		.getElementsByClassName('MuiPaginationItem-page')[0]
	// 		.classList.add('Mui-selected');
	// }
};

export const gymSlice = createSlice({
	name: 'gym',
	initialState,
	reducers: {
		// set difficulty
		setDifficulty: (state, action: PayloadAction<any>) => {
			state.difficulty[action.payload] =
				!state.difficulty[action.payload];
			state.page = '1';
			resetPageToOne();
		},
		setTags: (state, action: PayloadAction<any>) => {
			state.tags = action.payload;
			console.log('TAGS', state.tags, action.payload);
			state.page = '1';
			state.courseId = '';
			state.filterCourseName = '';
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			// document
			// 	.getElementById('default-module-option')
			// 	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// 	// @ts-ignore
			// 	.setAttribute('selected', true);
			resetPageToOne();
		},
		setName: (state, action: PayloadAction<any>) => {
			state.name = action.payload;
			state.page = '1';
			resetPageToOne();
		},
		setRevisionSheetId:(state, action: PayloadAction<any>)=>{
			state.revisionSheetId = action.payload
		},
		setCourseIdForFilter: (state, action: PayloadAction<any>) => {
			state.courseId = action.payload.id;
			state.filterCourseName = action.payload.name;
			state.page = '1';
			state.tags = [];
			resetPageToOne();
		},
		setPage: (state, action: PayloadAction<any>) => {
			console.log('pagination', action.payload);
			state.page = action.payload;
		},
		setType: (state, action: PayloadAction<any>) => {
			state.solvedStatus = action.payload;
			state.page = '1';
			resetPageToOne();
		},
		setBookmark: (state, action: PayloadAction<any>) => {
			state.bookmarked = action.payload;
			state.page = '1';
			resetPageToOne();
		},
		setQuestionSource: (state, action: PayloadAction<any>) => {
			state.questionSource = action.payload;
			state.page = '1';
			resetPageToOne();
		},
		setCurPageRange: (state, action: PayloadAction<any>) => {
			state.curPageRange = action.payload;
			state.page = '1';
			resetPageToOne();
		},
		setSolvedQuestion: (state, action: PayloadAction<any>) => {
			const data = state.filteredData;
			for (let i = 0; i < data.questions.length; i++) {
				if (data.questions[i].id === action.payload.id) {
					data.questions[i].solved = action.payload.solved;
				}
			}
			state.filteredData = data;
			state.page = '1';
			resetPageToOne();
		},
		resetAllFilter: (state) => {
			state.difficulty = [false, false, false];
			state.tags = [];
			state.name = '';
			state.solvedStatus = 2;
			state.bookmarked = false;
			state.courseId = '';
			state.questionSource = '';
			state.filterCourseName = '';
		},
	},
	extraReducers: {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[fetchGymQuestions.pending]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			state.gymloading = true;
			state.filteredData = null;
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[fetchGymQuestions.fulfilled]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			state.gymloading = false;
			state.filteredData = action.payload;
			state.error.state = false;
			state.error.message = '';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[fetchGymQuestions.rejected]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			state.gymloading = false;
			state.error.state = true;
			state.error.message = 'Error, please try again later';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[fetchGymConceptualQuestions.pending]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			state.gymloading = true;
			state.filteredData = null;
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[fetchGymConceptualQuestions.fulfilled]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			state.gymloading = false;
			state.filteredData = action.payload;
			state.error.state = false;
			state.error.message = '';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[fetchGymConceptualQuestions.rejected]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			state.gymloading = false;
			state.error.state = true;
			state.error.message = 'Error, please try again later';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[fetchWebDevGymQuestions.pending]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			state.gymloading = true;
			state.filteredData = null;
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[fetchWebDevGymQuestions.fulfilled]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			state.gymloading = false;
			state.filteredData = action.payload;
			state.error.state = false;
			state.error.message = '';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[fetchWebDevGymQuestions.rejected]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			state.gymloading = false;
			state.error.state = true;
			state.error.message = 'Error, please try again later';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[addBookmark.pending]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			// state.gymloading = false;
			// state.filteredData = action.payload;
			// state.error.state = false;
			// state.error.message = '';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[addBookmark.fulfilled]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			state.gymloading = false;
			state.filteredData = action.payload;
			state.error.state = false;
			state.error.message = '';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[addBookmark.rejected]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			// state.gymloading = false;
			// state.filteredData = action.payload;
			// state.error.state = false;
			// state.error.message = '';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[removeBookmark.pending]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			// state.gymloading = false;
			// state.filteredData = action.payload;
			// state.error.state = false;
			// state.error.message = '';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[removeBookmark.fulfilled]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			state.gymloading = false;
			state.filteredData = action.payload;
			state.error.state = false;
			state.error.message = '';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[removeBookmark.rejected]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			// state.gymloading = false;
			// state.filteredData = action.payload;
			// state.error.state = false;
			// state.error.message = '';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[getRevisionSheets.pending]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			state.gymloading = true;
			state.revisionSheets = [];
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[getRevisionSheets.fulfilled]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			state.gymloading = false;
			state.revisionSheets = action.payload;
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[getRevisionSheets.rejected]: (
			state: GymState,
			action: PayloadAction<any>,
		) => {
			state.gymloading = false;
			state.error.state = true;
			state.error.message = 'Error, please try again later';
		},
	},
});

//Exporting Actions
export const {
	setDifficulty,
	setTags,
	setName,
	setPage,
	setType,
	setBookmark,
	setCurPageRange,
	setSolvedQuestion,
	setCourseIdForFilter,
	setQuestionSource,
	resetAllFilter,
	setRevisionSheetId,
} = gymSlice.actions;
export default gymSlice.reducer;
